import React from 'react';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateHealthcareFacilityDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import ConfirmationButton from '../../../app/components/ConfirmationButton';
import momencik from '../../../common/momencik';

interface HealthcareFacilityAdvancedTabProps {
  healthcareFacility: CreateUpdateHealthcareFacilityDto;
  validFrom: Date | null;
  propertyChange: (obj: Partial<CreateUpdateHealthcareFacilityDto>) => void;
  onConfirmNewData: () => void;
  onCancelNewData: () => void;
  onValidFromChange: (date: Date) => void;
}

export const HealthcareFacilityAdvancedTab: React.FC<
  HealthcareFacilityAdvancedTabProps
> = props => {
  return (
    <div className="d-grid gap-3">
      {!props.healthcareFacility?.createNewHealthcareFacilityData ? (
        <>
          <Alert variant="warning">
            <Alert.Heading>Utwórz nowe dane placówki</Alert.Heading>
            Ta operacja spowoduje utworzenie nowych danych placówki. Bieżące
            dane zostaną zachowane jako historyczne, a nowe dane będą
            obowiązywać od wybranej daty.
          </Alert>
          <ConfirmationButton
            confirmation="Utwórz nowe dane placówki"
            warnings={[
              'Ta operacja spowoduje utworzenie nowych danych placówki. Bieżące dane zostaną zachowane jako historyczne, a nowe dane będą obowiązywać od wybranej daty.',
            ]}
            onOK={props.onConfirmNewData}
            confirmLabel="Potwierdź"
            rejectLabel="Anuluj"
          >
            Utwórz nowe dane
          </ConfirmationButton>
        </>
      ) : (
        <>
          <Alert variant="warning">✓ Będą utworzone nowe dane placówki</Alert>
          <FormRow controlId="validFrom" label="Data obowiązywania">
            <Form.Control
              type="date"
              value={momencik(props.validFrom, 'YYYY-MM-DD')}
              onChange={e => props.onValidFromChange(new Date(e.target.value))}
            />
          </FormRow>
          <Button variant="outline-secondary" onClick={props.onCancelNewData}>
            Anuluj tworzenie nowych danych
          </Button>
        </>
      )}
    </div>
  );
};
